export default {"src":"/_next/static/media/product-icon-light.0255c77c.svg","height":36,"width":37,"blurWidth":0,"blurHeight":0};